export default __webpack_public_path__ + "static/media/ico-propertibaru.26c0e0d4.webp";